// Informations demandées à un professionnel dans la demande de devis du simulateur. L'établissement coche
// celles qu'il veut et dit si elles sont obligatoires. Miroir de CHAMPS_DEMANDE_PRO dans functions/api.
export type CleChampPro = 'type_etablissement' | 'company_name' | 'address' | 'contact_nom' | 'contact_fonction' | 'phone' | 'siret';
export type ChampsPro = Record<CleChampPro, { demande: boolean; obligatoire: boolean }>;

export const LIBELLES_CHAMPS_PRO: { cle: CleChampPro; libelle: string; fixe?: boolean }[] = [
    { cle: 'company_name', libelle: "Nom de l'établissement", fixe: true },
    { cle: 'type_etablissement', libelle: "Type d'établissement (restaurant, hôtel…)" },
    { cle: 'address', libelle: 'Adresse, code postal et ville (avec recherche d\'adresse)' },
    { cle: 'contact_nom', libelle: 'Nom et prénom du contact' },
    { cle: 'contact_fonction', libelle: 'Fonction du contact' },
    { cle: 'phone', libelle: 'Téléphone' },
    { cle: 'siret', libelle: 'Numéro de SIRET' },
];

export const CHAMPS_PRO_PAR_DEFAUT: ChampsPro = {
    type_etablissement: { demande: false, obligatoire: false },
    company_name: { demande: true, obligatoire: true },
    address: { demande: true, obligatoire: false },
    contact_nom: { demande: true, obligatoire: false },
    contact_fonction: { demande: false, obligatoire: false },
    phone: { demande: true, obligatoire: true },
    siret: { demande: false, obligatoire: false },
};

export const lireChampsPro = (brut: any): ChampsPro => {
    const out = { ...CHAMPS_PRO_PAR_DEFAUT } as ChampsPro;
    (Object.keys(CHAMPS_PRO_PAR_DEFAUT) as CleChampPro[]).forEach((cle) => {
        const v = brut?.[cle];
        out[cle] = v && typeof v === 'object' ? { demande: !!v.demande, obligatoire: !!v.demande && !!v.obligatoire } : { ...CHAMPS_PRO_PAR_DEFAUT[cle] };
    });
    out.company_name = { demande: true, obligatoire: true };
    return out;
};
